import { RarityType } from 'entities/smartcontract';

export const rarityList: RarityType[] = [
    RarityType.common,
    RarityType.uncommon,
    RarityType.rare,
    RarityType.epic,
    RarityType.legendary,
];
